<template>
  <div class="dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 container mx-auto px-4">
    <ProfileSection />
    <DescriptionSection />
    <ExperienceSection />
    <TechnologyStackSection />
    <ProjectsSection />
    <ContactSection />
  </div>
</template>

<script>
import ProfileSection from '@/components/ProfileSection.vue';
import DescriptionSection from '@/components/DescriptionSection.vue';
import ExperienceSection from '@/components/ExperienceSection.vue';
import TechnologyStackSection from '@/components/TechnologyStackSection.vue';
import ProjectsSection from '@/components/ProjectsSection.vue';
import ContactSection from '@/components/ContactSection.vue';

export default {
  name: 'HomePage',
  components: {
    ProfileSection,
    DescriptionSection,
    ExperienceSection,
    TechnologyStackSection,
    ProjectsSection,
    ContactSection,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
